// extracted by mini-css-extract-plugin
module.exports = {"plansBlock":"view-plans_plansBlock_Ia37a"};